import { __assign } from "tslib";
import { alpha } from '@mui/system';
export var RadioTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState, theme = _a.theme;
            return ({
                padding: theme.spacing(1),
                color: 'currentColor',
                '&:hover': __assign(__assign({}, (ownerState.color &&
                    ownerState.color !== "default" && {
                    backgroundColor: alpha(theme.palette[ownerState.color][300], 0.08),
                })), (ownerState.color === 'default' && {
                    backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
                })),
                svg: {
                    fontSize: 16,
                    '&:first-of-type, &[data-testid="RadioButtonUncheckedIcon"]': __assign(__assign({}, (ownerState.color &&
                        ownerState.color !== "default" && {
                        fill: theme.palette[ownerState.color][300],
                    })), (ownerState.color === 'default' && {
                        fill: "currentColor",
                    })),
                },
                '&.Mui-checked': {
                    svg: {
                        '&:last-of-type, &[data-testid="RadioButtonCheckedIcon"]': __assign(__assign({}, (ownerState.color &&
                            ownerState.color !== "default" && {
                            fill: theme.palette[ownerState.color].main,
                        })), (ownerState.color === 'default' && {
                            fill: "currentColor",
                        })),
                    },
                },
                '&.Mui-disabled': {
                    opacity: 0.48,
                    color: "currentColor",
                    svg: {
                        '&:last-of-type, &[data-testid="RadioButtonCheckedIcon"]': __assign(__assign({}, (ownerState.color &&
                            ownerState.color !== "default" && {
                            fill: theme.palette[ownerState.color][300],
                        })), (ownerState.color === 'default' && {
                            fill: "currentColor",
                        })),
                    },
                },
            });
        },
    },
}); };
export default RadioTheme;
//# sourceMappingURL=theme.js.map